import React from 'react';
import { X, MapPinIcon } from 'lucide-react';
import { SearchBar } from './SearchBar';
import { cityPresets, useUserProfile } from '../context/UserProfileContext';
interface MobileSearchProps {
  onClose: () => void;
}
export const MobileSearch: React.FC<MobileSearchProps> = ({
  onClose
}) => {
  const {
    applyPresetPOIs,
    setSearchQuery
  } = useUserProfile();
  const handleCitySelect = (cityKey: string) => {
    setSearchQuery(cityPresets[cityKey].name);
    applyPresetPOIs(cityKey);
    onClose();
  };
  return <div className="fixed inset-0 bg-white z-[1001] flex flex-col" data-id="element-159">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-160">
        <button onClick={onClose} className="text-gray-500 hover:text-gray-700 p-2" data-id="element-161">
          <X size={24} data-id="element-162" />
        </button>
        <div className="text-lg font-medium" data-id="element-163">Search</div>
        <div className="w-6" data-id="element-164"></div> {/* Empty div for flex spacing */}
      </div>
      {/* Search content */}
      <div className="flex-1 p-4 overflow-y-auto" data-id="element-165">
        <div className="mb-6" data-id="element-166">
          <SearchBar isMobile={true} data-id="element-167" />
        </div>
        <div className="mt-8" data-id="element-168">
          <h3 className="text-lg font-semibold mb-4" data-id="element-169">Popular destinations</h3>
          <div className="grid grid-cols-2 gap-4" data-id="element-170">
            {Object.keys(cityPresets).map(cityKey => <div key={cityKey} className="aspect-square relative rounded-lg overflow-hidden cursor-pointer active:opacity-90" onClick={() => handleCitySelect(cityKey)} data-id="element-171">
                <img src={cityPresets[cityKey].image} alt={cityPresets[cityKey].name} className="absolute inset-0 w-full h-full object-cover" data-id="element-172" />
                <div className="absolute inset-0 bg-black bg-opacity-20" data-id="element-173"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/70 to-transparent" data-id="element-174">
                  <div className="flex items-center text-white" data-id="element-175">
                    <MapPinIcon size={14} className="mr-1" data-id="element-176" />
                    <span className="font-medium" data-id="element-177">
                      {cityPresets[cityKey].name}
                    </span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};